// extracted by mini-css-extract-plugin
export default {"section_divider":"section-divider_section_divider__tedJ-"};